const baseUrl = `https://idcksareport.com:8443`;



export {baseUrl};